import request from '@/utils/request'

/**
 * @desc 代理人信息
 */
export const simple = () => {
  return request.get('/app/promoter/simple')
}

/**
 * @desc 获取推广规则
 * @param {number} type - 0:入驻推广规则 1:佣金发放规则
 */
export const selectPromoterAgreement = (type) => {
  return request.get('/app/promoterAgreement/select', {
    params: {
      type
    }
  })
}

